import { ExcalidrawElement } from "../../element/types";
import { AppState } from "../../types";
import {
  clearAppStateForLocalStorage,
  getDefaultAppState,
} from "../../appState";
import { clearElementsForLocalStorage } from "../../element";
import { updateBrowserStateVersion } from "./tabSync";
import { STORAGE_KEYS } from "../app_constants";
import { setLanguage,t } from "../../i18n";
import ioDrawLib from "../../data/ioDrawLib.json";
import { get, set, createStore } from "idb-keyval";

const filesStore = createStore("files-db", "files-store");

export const saveUsernameToLocalStorage = (username: string) => {
  try {
    localStorage.setItem(
      STORAGE_KEYS.LOCAL_STORAGE_COLLAB,
      JSON.stringify({ username }),
    );
  } catch (error: any) {
    // Unable to access window.localStorage
    console.error(error);
  }
};

export const importUsernameFromLocalStorage = (): string | null => {
  try {
    const data = localStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_COLLAB);
    if (data) {
      return JSON.parse(data).username;
    }
  } catch (error: any) {
    // Unable to access localStorage
    console.error(error);
  }

  return null;
};

export const saveToLocalStorage = (
  elements: readonly ExcalidrawElement[],
  appState: AppState,
) => {
  try {
    sessionStorage.setItem(
      STORAGE_KEYS.LOCAL_STORAGE_ELEMENTS,
      JSON.stringify(clearElementsForLocalStorage(elements)),
    );
	
    sessionStorage.setItem(
      STORAGE_KEYS.LOCAL_STORAGE_APP_STATE,
      JSON.stringify(clearAppStateForLocalStorage(appState)),
    );
    updateBrowserStateVersion(STORAGE_KEYS.VERSION_DATA_STATE);
  } catch (error: any) {
    // Unable to access window.localStorage
    console.error(error);
  }
};



 
var i18nextLng = localStorage.getItem("i18nextLng");
var langFlag="";
if(i18nextLng=="zh-CN"||i18nextLng=="zh-TW"){
	langFlag="zh";
}else if(i18nextLng=="eu-ES"){
	langFlag="es";
}else if(i18nextLng=="ar-SA"){
	langFlag="ar";
}else if(i18nextLng=="fr-FR"){
	langFlag="fr";
}else if(i18nextLng=="pt-BR"){
	langFlag="pt";
}else if(i18nextLng=="ru-RU"){
	langFlag="ru";
}else if(i18nextLng=="ja-JP"){
	langFlag="ja";
}else if(i18nextLng=="de-DE"){
	langFlag="de";
}else if(i18nextLng=="it-IT"){
	langFlag="it";
}else if(i18nextLng=="en"){
	langFlag="en";
}
localStorage.setItem("iodrawLang",langFlag);
var langUrl = '/';
if(langFlag==null || langFlag==""){
	if(window.location.host.indexOf("iodraw")>-1){
		langFlag="zh";
		localStorage.setItem("i18nextLng","zh-CN");
		setLanguage({ code: "zh-CN", label: "简体中文" });
	}else{
		langFlag="en";
		localStorage.setItem("i18nextLng","en");
		setLanguage({ code: "en", label: "English" });
	}
	localStorage.setItem("iodrawLang",langFlag);
}else{
	langUrl='/'+langFlag+'/';
	if(window.location.host.indexOf("iodraw")>-1){
		if(langFlag=="zh"){
			langUrl='/';
		}
	}else if(langFlag=="en"){
		langUrl='/';
	}
}

var localFileId: any | null=null;
/* 
if(langFlag=='zh'){
	var common_disk_0='所有修订自动保存',common_disk_1='保存成功',common_disk_2='最近保存',common_disk_3='我的文件';
} else if(langFlag=='es'){
	var common_disk_0='Guardar automáticamente',common_disk_1='Guardar con éxito',common_disk_2='Guardar recientemente',common_disk_3='Mis archivos';
} else if(langFlag=='ar'){
	var common_disk_0='حفظ السيارات',common_disk_1='حفظ بنجاح',common_disk_2='حفظ مؤخرا',common_disk_3='ملفي';
} else if(langFlag=='fr'){
	var common_disk_0='Enregistrer automatiquement',common_disk_1='Enregistrer avec succès',common_disk_2='Récemment sauvegardé',common_disk_3='Mes dossiers';
} else if(langFlag=='pt'){
	var common_disk_0='Gravação automática',common_disk_1='Gravado com SUCESSO',common_disk_2='Gravado recentemente',common_disk_3='Meus arquivos.';
} else if(langFlag=='ru'){
	var common_disk_0='Автосохранение',common_disk_1='сохранить успешно',common_disk_2='Последнее сохранение',common_disk_3='мои файлы';
} else if(langFlag=='ja'){
	var common_disk_0='自動保存',common_disk_1='保存に成功しました',common_disk_2='最近の保存',common_disk_3='私のファイル';
} else if(langFlag=='de'){
	var common_disk_0='Automatisches Speichern',common_disk_1='Speichern erfolgreich',common_disk_2='Kürzlich gespeichert',common_disk_3='Meine Akten';
} else if(langFlag=='ko'){
	var common_disk_0='자동 저장',common_disk_1='저장 성공',common_disk_2='최근 저장',common_disk_3='내 서류';
} else if(langFlag=='it'){
	var common_disk_0='Salvataggio automatico',common_disk_1='Salvato con successo',common_disk_2='Recentemente salvato',common_disk_3='I miei file';
} else {
	var common_disk_0='Auto save',common_disk_1='Saved successfully',common_disk_2='Recently saved',common_disk_3='My files';
} 
//自动保存文件
var localFileId: any | null=null;
var initTxt: any | null=null;
var initTitle: any | null=null;
var filetb: any | null=null;
function getStrSize(txt: any){let size=txt.replace(/[^\u0000-\u00ff]/g,"aa").length;const arr=['B','KB','MB','GB','TB'];let sizeUnit=0;while(size>1024){size/=1024;++sizeUnit;}return size.toFixed(0)+arr[sizeUnit];}
function insertAfter(a: any,b: any){var parent=b.parentNode;if(parent.lastChild==b){parent.appendChild(a,b)}else{parent.insertBefore(a,b.nextSibling)}};
function localDB(callback: any,params: any) {
	var indexedDB = window.indexedDB || (window as any).webkitIndexedDB || (window as any).mozIndexedDB || (window as any).msIndexedDB;
	if(!indexedDB){return false;} 
	var request = window.indexedDB.open('iodrawdb',1);
	request.onsuccess = function (event) {
		var iodrawdb = request.result;
		filetb = iodrawdb.transaction(['file'], 'readwrite').objectStore('file');
		return callback(params);
	};
	request.onupgradeneeded = function (event) {
		var iodrawdb = (event as any).target.result;
		if (!iodrawdb.objectStoreNames.contains('file')) {
			filetb = iodrawdb.createObjectStore('file', { keyPath: 'id' });
			filetb.createIndex('title', 'title', { unique: true });
			return callback(params);
		}
	}
}
function saveFile(params: any) {
	var type=params.type;
	var title=params.title;
	var txt=params.txt;
	var txtNoFiles = JSON.parse(txt);
	txtNoFiles.files={};//去file
	var txtNoFilesStr=JSON.stringify(txtNoFiles);
	
	if(initTxt==null||initTitle==null){
		initTxt=txtNoFilesStr;
		initTitle=title;
		return false
	}
	if(initTxt==txtNoFilesStr && initTitle==title){
		return false
	}
	if(params.id!=null){
		var getOne=filetb.get(params.id);getOne.onsuccess=function(event: any){if(getOne.result){
		var db=getOne.result;
		if(txt==db.txt&&title==db.title){return false}
		db.txt=txt;db.size=getStrSize(txt);db.updateTime=new Date();db.syncCount=0;db.syncTime=null;
		if(title!=db.title){db.title=title;var requestQuery=window.indexedDB.open('iodrawdb',1);requestQuery.onsuccess=function(event){filetb=requestQuery.result.transaction(['file'],'readwrite').objectStore('file');
			var queryTitle=filetb.index('title').get(title);
			queryTitle.onsuccess=function(e: any){var result=e.target.result;
				if (result!=null && result.id!=db.id){
					params.title=getNewFileTitle(title);
					localDB(saveFile,params);
					return false;
				}
			}}	
		}
		var requestUpadate=window.indexedDB.open('iodrawdb',1);requestUpadate.onsuccess=function(event){filetb=requestUpadate.result.transaction(['file'],'readwrite').objectStore('file');
			var updateDB=filetb.put(db);
			updateDB.onsuccess=function(event: any){
				initTitle=db.title;
				var txtNoFilesStr = JSON.parse(db.txt);
				txtNoFilesStr.files={};//去file
				initTxt=JSON.stringify(txtNoFilesStr);
				(document as any).getElementById("fileTitleInput").value=db.title.substring(0,db.title.lastIndexOf("."));
				showFileMsg();
				uploadBaiduPan(db);
			}
			updateDB.onerror=function(event: any){}
		}}}
	}else{
		var queryTitle=filetb.index('title').get(title);
		queryTitle.onsuccess=function(e: any){
			var result = e.target.result;
			if (result!=null) {
				params.title=getNewFileTitle(title);
				localDB(saveFile,params);
				return false;
			}
		}
		var requestAdd = window.indexedDB.open('iodrawdb',1);
		requestAdd.onsuccess=function(event: any){filetb=requestAdd.result.transaction(['file'],'readwrite').objectStore('file');
			var now=new Date();
			var obj={id:now.getTime(),title:title,type:type,size:getStrSize(txt),updateTime:now,txt:txt,status:1,syncTime:null,syncCount:0,syncTitle:null};
			var addDB = filetb.add(obj);
			addDB.onsuccess=function(event: any){
				localFileId=obj.id;
				sessionStorage.setItem("localFileId4",localFileId);
				initTitle=title;
				var txtNoFilesStr = JSON.parse(txt);
				txtNoFilesStr.files={};//去file
				initTxt=JSON.stringify(txtNoFilesStr);
				(document as any).getElementById("fileTitleInput").value=title.substring(0,title.lastIndexOf("."));
				showFileMsg();
				uploadBaiduPan(obj);
			}
			addDB.onerror=function(event: any){}
		}	
	}
}
function uploadBaiduPan(obj: any){
	var baiduToken=localStorage.getItem("baiduToken");
	var baiduUinfo=localStorage.getItem("baiduUinfo");
	var syncBaiduPanTime=localStorage.getItem("syncBaiduPanTime");
	if(baiduToken==null){return false}
	if(baiduUinfo==null||baiduUinfo==""){return false}
	if(syncBaiduPanTime!=null&&(new Date().getTime()-(syncBaiduPanTime as any))<60*1000){return false}
	if(obj.syncCount>3){return false}
	if(obj.txt.replace(/[^\u0000-\u00ff]/g,"aa").length>1*1024*1024){return false}
	var nowDate=new Date();
	localStorage.setItem("syncBaiduPanTime",(nowDate as any).getTime());
	obj.syncCount=obj.syncCount+1;
	var request1=window.indexedDB.open('iodrawdb',1);request1.onsuccess=function(event){filetb=request1.result.transaction(['file'],'readwrite').objectStore('file');
	var update1=filetb.put(obj);
	update1.onsuccess=function(event: any){
		var oldSyncTitle=obj.syncTitle;
		var xhr=new XMLHttpRequest();
		xhr.open('POST',"/member/fileSave.json",true);
		xhr.setRequestHeader('content-type','application/json;charset=utf-8;');
		xhr.send(JSON.stringify({"title":(oldSyncTitle==null?obj.title:oldSyncTitle),"token":baiduToken,"txt":obj.txt}));
		xhr.onreadystatechange=function(){
			if (xhr.readyState==4&&xhr.status==200) {
				if(xhr.responseText=="0"){
					obj.syncCount=0;
					obj.syncTime=new Date();
					obj.syncTitle=obj.title;
					var request2=window.indexedDB.open('iodrawdb',1);request2.onsuccess=function(event){filetb=request2.result.transaction(['file'],'readwrite').objectStore('file');
					var update2=filetb.put(obj);
					update2.onsuccess=function(event: any){
						if(oldSyncTitle!=null && oldSyncTitle!=obj.title){
							var xhr2=new XMLHttpRequest();
							xhr2.open('POST',"/member/fileRename.json?oldName="+oldSyncTitle+"&newName="+obj.title+"&token="+baiduToken,true);
							xhr2.send();
						}
					}}
				}else if(xhr.responseText=="-6"){
					localStorage.removeItem("baiduUinfo");
					localStorage.removeItem("baiduToken");
					localStorage.removeItem("baiduFiles");
				}
			}
		}
	}}
}
function getNewFileTitle(title: any){
	var fileName=title.substring(0,title.lastIndexOf("."));
	var fileSuffix=title.substring(title.lastIndexOf("."));
	var suffix=fileName.lastIndexOf("-")<0?0:fileName.substring(fileName.lastIndexOf("-")+1);
	var prefix=fileName.lastIndexOf("-")<0?fileName:fileName.substring(0,fileName.lastIndexOf("-"));
	var newSuffix=(/^\d+$/.test(suffix)==true)?(parseInt(suffix)+1):1;
	return prefix+"-"+newSuffix+fileSuffix;
}
export const showFileMsg = () => {
	var showFileMsg=document.getElementById("showFileMsg");
	var size=12;
	var r=size/20;
	var color="rgb(129,134,143)";
	if(showFileMsg==null){
		showFileMsg=document.createElement("div");
		showFileMsg.setAttribute("id","showFileMsg");
		showFileMsg.style.margin="5px";
		showFileMsg.style.verticalAlign="bottom";
		insertAfter(showFileMsg,document.getElementById("fileTitleInput"));
		var style='<style>@keyframes circle{from{stroke-dashoffset:1194}to{stroke-dashoffset:2388}} @keyframes tick{from{stroke-dashoffset:35}to{stroke-dashoffset:0}} @keyframes title{from{opacity:1}to{opacity:1}}</style>';
		var svg='<svg width="'+20*r+'px" height="'+20*r+'px"><circle r="'+9*r+'" class="circle" fill="none" stroke="'+color+'" stroke-width="'+1*r+'" cx="'+10*r+'" cy="'+10*r+'" stroke-linecap="round" transform="rotate('+-9*r+' '+10*r+' '+10*r+')" style="stroke-dasharray:1194;stroke-dashoffset:1194;animation:circle 0s ease-in-out;animation-fill-mode:forwards"></circle><polyline fill="none" stroke="'+color+'" stroke-width="1" points="'+4.4*r+','+10.7*r+' '+8.6*r+','+13.7*r+' '+15.2*r+','+6.9*r+'" stroke-linecap="round" stroke-linejoin="round" class="tick" style="stroke-dasharray:'+35*r+';stroke-dashoffset:'+35*r+';animation:tick 0s ease-out;animation-fill-mode:forwards;animation-delay:0s"></polyline></svg>';
		var div='<a id="showFileMsgDiv" href="'+langUrl+'disk" target="_blank" style="font-size:'+20*r+'px;font-weight:500;cursor:pointer;margin-left:5px;color:'+color+';opacity:0;animation:0s title ease-in-out;animation-delay:0s;animation-fill-mode:forwards;"></a>';
		showFileMsg.innerHTML=style+svg+div;
		var showFileMsgDiv=document.getElementById("showFileMsgDiv");
		(showFileMsgDiv as any).innerText=common_disk_0;
		return false;
	}
	if(loopStart==false){
		return false;
	}
	loopStart=false;
	
	showFileMsg.innerHTML='';

	var style='<style>@keyframes circle{from{stroke-dashoffset:1194}to{stroke-dashoffset:2388}} @keyframes tick{from{stroke-dashoffset:35}to{stroke-dashoffset:0}} @keyframes title{from{opacity:0}to{opacity:1}}</style>';
	var svg='<svg width="'+20*r+'px" height="'+20*r+'px"><circle r="'+9*r+'" class="circle" fill="none" stroke="'+color+'" stroke-width="'+1*r+'" cx="'+10*r+'" cy="'+10*r+'" stroke-linecap="round" transform="rotate('+-9*r+' '+10*r+' '+10*r+')" style="stroke-dasharray:1194;stroke-dashoffset:1194;animation:circle 0.6s ease-in-out;animation-fill-mode:forwards"></circle><polyline fill="none" stroke="'+color+'" stroke-width="1" points="'+4.4*r+','+10.7*r+' '+8.6*r+','+13.7*r+' '+15.2*r+','+6.9*r+'" stroke-linecap="round" stroke-linejoin="round" class="tick" style="stroke-dasharray:'+35*r+';stroke-dashoffset:'+35*r+';animation:tick 0.4s ease-out;animation-fill-mode:forwards;animation-delay:0.55s"></polyline></svg>';
	var div='<a id="showFileMsgDiv" href="'+langUrl+'disk" target="_blank" style="font-size:'+20*r+'px;font-weight:500;cursor:pointer;margin-left:5px;color:'+color+';opacity:0;animation:0.2s title ease-in-out;animation-delay:0.4s;animation-fill-mode:forwards;"></a>';
	showFileMsg.innerHTML=style+svg+div;
	var showFileMsgDiv=document.getElementById("showFileMsgDiv");
	(showFileMsgDiv as any).innerText=common_disk_1;
	var time=new Date();
	var hour = time.getHours() > 9 && time.getHours() || ('0' + time.getHours())
	var minute = time.getMinutes() > 9 && time.getMinutes() || ('0' + time.getMinutes())
	setTimeout(function(){(showFileMsgDiv as any).innerText=common_disk_2+" "+hour+':'+minute},3000);
}
var loopStart=false;
const autoSaveFile = async () => {
	loopStart=true;
	var elementsVlue = sessionStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_ELEMENTS);
	if(elementsVlue==null || elementsVlue==""){
		return false;
	}
	var fileTitleInput=document.getElementById("fileTitleInput");
	if(fileTitleInput==null||(fileTitleInput as any).value==""){return false}
	var j='{"type":"wb","version":2,"source":"https://www.iodraw.com","elements":'
	+elementsVlue
	+',"appState":'
	+sessionStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_APP_STATE)
	+',"files":{}}';
	var jsonObj=JSON.parse(j);
	let files: any = {};
	for(let i=0;i<jsonObj.elements.length;i++){
		var fileId="";
		if(jsonObj.elements[i].type=="image"){
		  fileId=jsonObj.elements[i].fileId;
		  if(fileId!=null&&fileId!=""){
			files[fileId] = await get(fileId as any, filesStore);
		  }
		  jsonObj.files=files;
		}
	}
	localDB(saveFile,{id:localFileId,type:4,title:(fileTitleInput as any).value+".wb",txt:JSON.stringify(jsonObj)});
}  
setInterval(autoSaveFile, 12000);

*/

export const importFromLocalStorage = () => {
  let savedElements = null;
  let savedState = null;

  try {
    savedElements = sessionStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_ELEMENTS);
	savedState = sessionStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_APP_STATE);
  } catch (error: any) {
    // Unable to access localStorage
    console.error(error);
  }

  let elements: ExcalidrawElement[] = [];
  if (savedElements) {
    try {
      elements = clearElementsForLocalStorage(JSON.parse(savedElements));
    } catch (error: any) {
      console.error(error);
      // Do nothing because elements array is already empty
    }
  }

  let appState = null;
  if (savedState) {
    try {
      appState = {
        ...getDefaultAppState(),
        ...clearAppStateForLocalStorage(
          JSON.parse(savedState) as Partial<AppState>,
        ),
      };
    } catch (error: any) {
      console.error(error);
      // Do nothing because appState is already null
    }
  }

  return { elements, appState };
};


//显示文件名
window.onload=function (){//图片加载完后执行
  var untitled = `${t("labels.untitled")}`;
  var showFileName=document.createElement("div");
  showFileName.id="fileTitleDiv";
  
  showFileName.innerHTML='<a href="'+langUrl+'" target="_blank"><svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="36" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M916 907.2c0 27-21.9 48.8-48.8 48.8h-710c-27 0-48.8-21.9-48.8-48.8V459.3c0-0.9 0-1.7 0.1-2.6-2.4-20.5 4.7-41.8 21.4-57.5L459.2 88.6c29.1-27.5 76.3-27.5 105.4 0L894 399.2c15.8 14.9 23 34.8 21.7 54.3 0.2 1.9 0.4 3.9 0.4 5.8v447.9zM640.9 741.5c0-63.8-53.9-115.5-120.4-115.5s-120.4 51.7-120.4 115.5V956h240.7V741.5z" fill="#515151"></path></svg></a>'
  +'<input id="fileTitleInput" onblur="autoSaveFile()" value="'+untitled+'" title="'+untitled+'" style="width: 158px;">'
  +'<div id="showFileMsg" style="margin: 5px; vertical-align: bottom;">';
  (document as any).querySelector(".leftTopIslandCol").insertBefore(showFileName, (document as any).querySelector(".leftTopIslandCol").firstElementChild);
  //showFileMsg();
  //(document as any).getElementById("fileTitleInput").onblur=function(){autoSaveFile()}
  
  var whiteboardUrl=window.location.href.split("#U")[1];
  if(typeof whiteboardUrl!="undefined"&&whiteboardUrl!=""){
	if(whiteboardUrl.indexOf("disk")==0){
		var requestDB=window.indexedDB.open('iodrawdb',1);requestDB.onsuccess=function(event){var filetb=requestDB.result.transaction(['file'],'readwrite').objectStore('file');
		var getOne=filetb.get(parseInt(whiteboardUrl.substring(4)));
		getOne.onsuccess=function(event){if(getOne.result){
			var db=getOne.result;
			var txtJSON = JSON.parse(db.txt);
			(document as any).getElementById("fileTitleInput").value=db.title.substring(0,db.title.lastIndexOf("."));
			localFileId=db.id;
		}}}
	}else if(whiteboardUrl.indexOf("?title=")>-1){
		var title=whiteboardUrl.split("?title=")[1];
		if(typeof title!="undefined" && title!=""){
			(document as any).getElementById("fileTitleInput").value=decodeURIComponent(title);
		}
	}
  }
  //autoSaveFile();
}
  
export const getElementsStorageSize = () => {
  try {
    const elements = sessionStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_ELEMENTS);
    const elementsSize = elements?.length || 0;
    return elementsSize;
  } catch (error: any) {
    console.error(error);
    return 0;
  }
};

export const getTotalStorageSize = () => {
  try {
    const appState = sessionStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_APP_STATE);
    const collab = localStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_COLLAB);
    const library = localStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_LIBRARY);

    const appStateSize = appState?.length || 0;
    const collabSize = collab?.length || 0;
    const librarySize = library?.length || 0;

    return appStateSize + collabSize + librarySize + getElementsStorageSize();
  } catch (error: any) {
    console.error(error);
    return 0;
  }
};

export const ioDrawLibItems=JSON.stringify(ioDrawLib);
export const getLibraryItemsFromStorage = () => {
  try {
	  //拼接ioDraw模板
	  //var jsonObj=JSON.parse(libStr);
    const libraryItems =
      JSON.parse(
        localStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE_LIBRARY) as string,
      ) || [];
	const newLibraryItems=libraryItems.concat(ioDrawLib);
	return newLibraryItems;
  } catch (e) {
    console.error(e);
    return [];
  }
};
